import { Injectable } from '@angular/core';
import {protectedResources} from "../../auth-config";
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class InternalUserService {
  brennerSoftwareApiEndpoint: string = protectedResources.BrennerSoftwareApi.endpoint;

  constructor(
    private http: HttpClient
  ) {}

  getUsers(): Observable<any> {
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `internalUser/getList/`)
      .pipe(map(users => {
        return users?.value
          .map(user => {
            return {
              ...user,
              customerId: user?.additionalData?.extension_2158d7c194fc47be9389db84b35b0240_CustomerId ?? user?.additionalData?.extension_7df8d27c03a94d7585a0ade9e9eeb2a3_CustomerId ?? '',
              firstName: user?.additionalData?.extension_2158d7c194fc47be9389db84b35b0240_FirstName ?? user?.additionalData?.extension_7df8d27c03a94d7585a0ade9e9eeb2a3_FirstName ?? '',
              lastName: user?.additionalData?.extension_2158d7c194fc47be9389db84b35b0240_LastName ?? user?.additionalData?.extension_7df8d27c03a94d7585a0ade9e9eeb2a3_LastName ?? '',
              roleId: user?.additionalData?.extension_2158d7c194fc47be9389db84b35b0240_RoleId ?? user?.additionalData?.extension_7df8d27c03a94d7585a0ade9e9eeb2a3_RoleId ?? '',
              emailAddress: user?.identities.find(x => x.signInType === 'emailAddress')?.issuerAssignedId,
            }
          })
      }));
  }

  updateUserCustomerId(userId: string, newCustomerId: string){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `internalUser/updateUsersCustomerId/`, {
      userId,
      newCustomerId
    })
  }

  updateUserRoles(userId: string, roleId: string){
    return this.http.post<any>(this.brennerSoftwareApiEndpoint + `internalUser/updateUsersRoleId/`, {
      userId,
      roleId
    })
  }

  getTenantsListOfUserRoles(){
    return this.http.get<any>(this.brennerSoftwareApiEndpoint + `internalUser/getTenantsListOfUserRoles/`);
  }

}
